const CLEAR_SONG = 'clear_song'
const DECREMENT_OFFSET = 'decrement_offset'
const GET_STATE = 'get_state'
const INCREMENT_OFFSET = 'increment_offset'
const INCREMENT_TIMER = 'increment_timer'
const PLAYER_STOP = 'player_stop'
const RESET_TIMER = 'reset_timer'
const SET_OFFSET = 'set_offset'
const START_TIMER = 'start_timer'
const STOP_TIMER = 'stop_timer'
const TOGGLE_MINIMIZED_APP = 'toggle_minimized_app'
const TOGGLE_OFFSET_VIEW = 'toggle_offset_view'
const UPDATE_SONG = 'update_song'
const UPDATE_STATUS = 'update_status'

export default {
  CLEAR_SONG,
  DECREMENT_OFFSET,
  GET_STATE,
  INCREMENT_OFFSET,
  INCREMENT_TIMER,
  PLAYER_STOP,
  RESET_TIMER,
  SET_OFFSET,
  START_TIMER,
  STOP_TIMER,
  TOGGLE_MINIMIZED_APP,
  TOGGLE_OFFSET_VIEW,
  UPDATE_SONG,
  UPDATE_STATUS
}



// WEBPACK FOOTER //
// ./src/duck/types.js